module.exports = __webpack_public_path__ + "img/image-03.463d9ff3.jpg";